import React from "react";
import { Form } from "react-bootstrap";
import { cities, vehicle_category, vehicle_make } from "./utils";

function VehicleDetails({
  continueStepEvent,
  backStepEvent,
  handleChange,
  formObj,
  isPreview,
  comboResponse,
}) {
  const detailObject = formObj.finDetailObj;

  const continueFormEvent = (e) => {
    e.preventDefault();
    continueStepEvent("finDetailObj");
  };

  return (
    <div className="tab-pane" role="tabpanel" id="step5">
      <Form onSubmit={(e) => continueFormEvent(e)}>
        <div className="row">
          <h4 className="my-3">Vehicle Details </h4>

          <div className="col-md-4">
            <div className="form-group">
              <label>Vehicle Make *</label>
              <Form.Select
                value={detailObject.vehicle_make.value}
                className="form-control"
                required
                disabled={isPreview ? true : false}
                placeholder="Select Financing Option"
                onChange={(e) =>
                  handleChange(e, "finDetailObj", "vehicle_make")
                }
              >
                <option value="">Select Vehicle Make</option>
                {comboResponse?.Vehicle_Make.map((item, index) => {
                  return (
                    <option key={index} value={item.key}>
                      {item.value}
                    </option>
                  );
                })}
              </Form.Select>
            </div>
          </div>

          <div className="col-md-4">
            <div className="form-group">
              <label>City *</label>
              <Form.Select
                value={detailObject.city.value}
                className="form-control"
                required
                disabled={isPreview ? true : false}
                placeholder="Select Financing Option"
                onChange={(e) => handleChange(e, "finDetailObj", "city")}
              >
                <option value="">Select City</option>
                {comboResponse?.City.map((item, index) => {
                  return (
                    <option key={index} value={item.key}>
                      {item.value}
                    </option>
                  );
                })}
              </Form.Select>
            </div>
          </div>

          <div className="col-md-4">
            <div className="form-group">
              <label>Vehicle Category *</label>
              <Form.Select
                value={detailObject.vehicle_category.value}
                className="form-control"
                required
                disabled={isPreview ? true : false}
                placeholder="Select Financing Option"
                onChange={(e) =>
                  handleChange(e, "finDetailObj", "vehicle_category")
                }
              >
                <option value="">Select Vehicle Category</option>
                {vehicle_category.map((item, index) => {
                  return (
                    <option key={index} value={item}>
                      {item}
                    </option>
                  );
                })}
              </Form.Select>
            </div>
          </div>

          <div className="col-md-4">
            <div className="form-group">
              <label>Vehicle Model *</label>
              <input
                required
                value={detailObject.vehicle_model.value}
                onChange={(e) =>
                  handleChange(e, "finDetailObj", "vehicle_model")
                }
                className="form-control"
                type="text"
                placeholder="Enter Vehicle Model Year"
                disabled={isPreview ? true : false}
              />
            </div>
          </div>

          <div className="col-md-4">
            <label>Financing Tenure *</label>
            <Form.Select
              value={detailObject.financing_tenure.value}
              className="form-control"
              type="number"
              required
              disabled={isPreview ? true : false}
              placeholder="Select Pricing Option"
              onChange={(e) =>
                handleChange(e, "finDetailObj", "financing_tenure")
              }
            >
              <option value="">Select Financing Tenure</option>
              {comboResponse?.Financing_Tenure.map((item, index) => {
                return (
                  <option key={index} value={item.key}>
                    {item.value}
                  </option>
                );
              })}
            </Form.Select>
          </div>

          <div className="col-md-4">
            <label>Insurance Company *</label>
            <Form.Select
              value={detailObject.preferred_insurance_company.value}
              className="form-control"
              type="number"
              required
              disabled={isPreview ? true : false}
              placeholder="Select Insurance Company"
              onChange={(e) =>
                handleChange(e, "finDetailObj", "preferred_insurance_company")
              }
            >
              <option value="">Select Insurance Option</option>
              {comboResponse?.Insurance_company.map((item, index) => {
                return (
                  <option key={index} value={item.key}>
                    {item.value}
                  </option>
                );
              })}
            </Form.Select>
          </div>

          <div className="col-md-4">
            <div className="form-group">
              <label>Vehicle Price *</label>
              <input
                required
                value={detailObject.vehicle_price.value}
                onChange={(e) =>
                  handleChange(e, "finDetailObj", "vehicle_price")
                }
                className="form-control"
                type="text"
                placeholder="Enter Vehicle Price"
                disabled={isPreview ? true : false}
              />
            </div>
          </div>

          <div className="col-md-4">
            <div className="form-group">
              <label>Financing Amount *</label>
              <input
                value={detailObject.financing_amount.value}
                onChange={(e) =>
                  handleChange(e, "finDetailObj", "financing_amount")
                }
                className="form-control"
                type="text"
                placeholder="Enter Financing Amount (Rs.)"
                disabled={isPreview ? true : false}
              />
            </div>
          </div>

          <div className="col-md-4">
            <label>Equity Contribution Option (Percentage)*</label>
            <Form.Select
              value={detailObject.equity_contribution_option.value}
              className="form-control"
              type="number"
              required
              disabled={isPreview ? true : false}
              placeholder="Select Equity Contribution Option"
              onChange={(e) =>
                handleChange(e, "finDetailObj", "equity_contribution_option")
              }
            >
              <option value="">Select Equity Contribution Option</option>
              {comboResponse?.Percentage.map((item, index) => {
                return (
                  <option key={index} value={item.key}>
                    {item.value}
                  </option>
                );
              })}
            </Form.Select>
          </div>

      
        </div>

       


        {/* To View Final Page Details */}
        {!isPreview ? (
          <ul className="list-inline pull-right">
            <li>
              <button
                type="button"
                className="default-btn prev-step"
                onClick={backStepEvent}
              >
                Back
              </button>
            </li>
            <li></li>
            <li>
              <button type="submit" className="default-btn next-step">
                Continue
              </button>
            </li>
          </ul>
        ) : (
          ""
        )}
      </Form>
    </div>
  );
}

export default VehicleDetails;
